import { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLogged, setIsLogged] = useState(false);
    const [userRole, setUserRole] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkLoginStatus = () => {
            const userSession = localStorage.getItem('userSession');
            const token = localStorage.getItem('authToken');
            
            if (userSession && token) {
                setIsLogged(true);
                
                // Try to get user role from JWT token
                try {
                    // JWT tokens are in format: header.payload.signature
                    // We need the payload part
                    const payload = token.split('.')[1];
                    const decodedPayload = JSON.parse(atob(payload));
                    
                    // Set user role from token
                    if (decodedPayload && decodedPayload.role) {
                        setUserRole(decodedPayload.role);
                    }
                } catch (error) {
                    console.error("Error decoding token:", error);
                }
            } else {
                setIsLogged(false);
                setUserRole(null);
            }
            
            setIsLoading(false);
        };

        checkLoginStatus();
    }, []);

    const login = (token, role) => {
        setIsLogged(true);
        setUserRole(role);
        localStorage.setItem('authToken', token);
        localStorage.setItem('userSession', JSON.stringify({ isLoggedIn: true }));
    };

    const logout = () => {
        setIsLogged(false);
        setUserRole(null);
        localStorage.removeItem('authToken');
        localStorage.removeItem('userSession');
    };

    return (
        <AuthContext.Provider value={{ 
            isLogged, 
            setIsLogged, 
            userRole, 
            setUserRole,
            isLoading,
            login,
            logout
        }}>
            {children}
        </AuthContext.Provider>
    );
};
